/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R404RouteImport } from './routes/404'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AgenticAiBuilderEarlyAccessRouteImport } from './routes/agentic-ai-builder-early-access'
import { Route as ConductorLicenseRouteImport } from './routes/conductor-license'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CurrentThankYouRouteImport } from './routes/current-thank-you'
import { Route as CustomerStoriesRouteImport } from './routes/customer-stories'
import { Route as DailyDbosActionsCountRouteImport } from './routes/daily-dbos-actions-count'
import { Route as DbosConductorRouteImport } from './routes/dbos-conductor'
import { Route as DbosPricingRouteImport } from './routes/dbos-pricing'
import { Route as DbosTransactRouteImport } from './routes/dbos-transact'
import { Route as DbosUserGroupMeetingRouteImport } from './routes/dbos-user-group-meeting'
import { Route as OpnPledgeRouteImport } from './routes/opn-pledge'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ServerlessPastPresentFutureRouteImport } from './routes/serverless-past-present-future'
import { Route as StartupRouteImport } from './routes/startup'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as UnbreakableAiWorkflowsBauplanRouteImport } from './routes/unbreakable-ai-workflows-bauplan'
import { Route as VideosRouteImport } from './routes/videos'
import { Route as Webcast2025InReviewWithMikeStonebrakerAndAndyPavloRouteImport } from './routes/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo'
import { Route as WebcastDbosConductorIntroRouteImport } from './routes/webcast-dbos-conductor-intro'
import { Route as WebcastDbosTransactTypescript2RouteImport } from './routes/webcast-dbos-transact-typescript-2'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as CaseStudiesSlugRouteImport } from './routes/case-studies/$slug'
import { Route as CompareDbosVsTemporalRouteImport } from './routes/compare/dbos-vs-temporal'
import { Route as JobsIndexRouteImport } from './routes/jobs/index'
import { Route as JobsKeepMeInMindRouteImport } from './routes/jobs/keep-me-in-mind'
import { Route as PartnershipsSlugRouteImport } from './routes/partnerships/$slug'
import { Route as SolutionsAgenticAiPlatformRouteImport } from './routes/solutions/agentic-ai-platform'
import { Route as SolutionsCloudModernizationRouteImport } from './routes/solutions/cloud-modernization'
import { Route as SolutionsCronHostingRouteImport } from './routes/solutions/cron-hosting'
import { Route as SolutionsDataPipelinePlatformRouteImport } from './routes/solutions/data-pipeline-platform'
import { Route as SolutionsDurableWeb3WorkflowsRouteImport } from './routes/solutions/durable-web3-workflows'
import { Route as SolutionsPliableRouteImport } from './routes/solutions/pliable'
import { Route as WebcastSlugRouteImport } from './routes/webcast/$slug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AgenticAiBuilderEarlyAccessRoute =
  AgenticAiBuilderEarlyAccessRouteImport.update({
    id: '/agentic-ai-builder-early-access',
    path: '/agentic-ai-builder-early-access',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConductorLicenseRoute = ConductorLicenseRouteImport.update({
  id: '/conductor-license',
  path: '/conductor-license',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CurrentThankYouRoute = CurrentThankYouRouteImport.update({
  id: '/current-thank-you',
  path: '/current-thank-you',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerStoriesRoute = CustomerStoriesRouteImport.update({
  id: '/customer-stories',
  path: '/customer-stories',
  getParentRoute: () => rootRouteImport,
} as any)
const DailyDbosActionsCountRoute = DailyDbosActionsCountRouteImport.update({
  id: '/daily-dbos-actions-count',
  path: '/daily-dbos-actions-count',
  getParentRoute: () => rootRouteImport,
} as any)
const DbosConductorRoute = DbosConductorRouteImport.update({
  id: '/dbos-conductor',
  path: '/dbos-conductor',
  getParentRoute: () => rootRouteImport,
} as any)
const DbosPricingRoute = DbosPricingRouteImport.update({
  id: '/dbos-pricing',
  path: '/dbos-pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const DbosTransactRoute = DbosTransactRouteImport.update({
  id: '/dbos-transact',
  path: '/dbos-transact',
  getParentRoute: () => rootRouteImport,
} as any)
const DbosUserGroupMeetingRoute = DbosUserGroupMeetingRouteImport.update({
  id: '/dbos-user-group-meeting',
  path: '/dbos-user-group-meeting',
  getParentRoute: () => rootRouteImport,
} as any)
const OpnPledgeRoute = OpnPledgeRouteImport.update({
  id: '/opn-pledge',
  path: '/opn-pledge',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersRoute = PartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ServerlessPastPresentFutureRoute =
  ServerlessPastPresentFutureRouteImport.update({
    id: '/serverless-past-present-future',
    path: '/serverless-past-present-future',
    getParentRoute: () => rootRouteImport,
  } as any)
const StartupRoute = StartupRouteImport.update({
  id: '/startup',
  path: '/startup',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const UnbreakableAiWorkflowsBauplanRoute =
  UnbreakableAiWorkflowsBauplanRouteImport.update({
    id: '/unbreakable-ai-workflows-bauplan',
    path: '/unbreakable-ai-workflows-bauplan',
    getParentRoute: () => rootRouteImport,
  } as any)
const VideosRoute = VideosRouteImport.update({
  id: '/videos',
  path: '/videos',
  getParentRoute: () => rootRouteImport,
} as any)
const Webcast2025InReviewWithMikeStonebrakerAndAndyPavloRoute =
  Webcast2025InReviewWithMikeStonebrakerAndAndyPavloRouteImport.update({
    id: '/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo',
    path: '/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo',
    getParentRoute: () => rootRouteImport,
  } as any)
const WebcastDbosConductorIntroRoute =
  WebcastDbosConductorIntroRouteImport.update({
    id: '/webcast-dbos-conductor-intro',
    path: '/webcast-dbos-conductor-intro',
    getParentRoute: () => rootRouteImport,
  } as any)
const WebcastDbosTransactTypescript2Route =
  WebcastDbosTransactTypescript2RouteImport.update({
    id: '/webcast-dbos-transact-typescript-2',
    path: '/webcast-dbos-transact-typescript-2',
    getParentRoute: () => rootRouteImport,
  } as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CaseStudiesSlugRoute = CaseStudiesSlugRouteImport.update({
  id: '/case-studies/$slug',
  path: '/case-studies/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareDbosVsTemporalRoute = CompareDbosVsTemporalRouteImport.update({
  id: '/compare/dbos-vs-temporal',
  path: '/compare/dbos-vs-temporal',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsIndexRoute = JobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsKeepMeInMindRoute = JobsKeepMeInMindRouteImport.update({
  id: '/jobs/keep-me-in-mind',
  path: '/jobs/keep-me-in-mind',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnershipsSlugRoute = PartnershipsSlugRouteImport.update({
  id: '/partnerships/$slug',
  path: '/partnerships/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsAgenticAiPlatformRoute =
  SolutionsAgenticAiPlatformRouteImport.update({
    id: '/solutions/agentic-ai-platform',
    path: '/solutions/agentic-ai-platform',
    getParentRoute: () => rootRouteImport,
  } as any)
const SolutionsCloudModernizationRoute =
  SolutionsCloudModernizationRouteImport.update({
    id: '/solutions/cloud-modernization',
    path: '/solutions/cloud-modernization',
    getParentRoute: () => rootRouteImport,
  } as any)
const SolutionsCronHostingRoute = SolutionsCronHostingRouteImport.update({
  id: '/solutions/cron-hosting',
  path: '/solutions/cron-hosting',
  getParentRoute: () => rootRouteImport,
} as any)
const SolutionsDataPipelinePlatformRoute =
  SolutionsDataPipelinePlatformRouteImport.update({
    id: '/solutions/data-pipeline-platform',
    path: '/solutions/data-pipeline-platform',
    getParentRoute: () => rootRouteImport,
  } as any)
const SolutionsDurableWeb3WorkflowsRoute =
  SolutionsDurableWeb3WorkflowsRouteImport.update({
    id: '/solutions/durable-web3-workflows',
    path: '/solutions/durable-web3-workflows',
    getParentRoute: () => rootRouteImport,
  } as any)
const SolutionsPliableRoute = SolutionsPliableRouteImport.update({
  id: '/solutions/pliable',
  path: '/solutions/pliable',
  getParentRoute: () => rootRouteImport,
} as any)
const WebcastSlugRoute = WebcastSlugRouteImport.update({
  id: '/webcast/$slug',
  path: '/webcast/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/agentic-ai-builder-early-access': typeof AgenticAiBuilderEarlyAccessRoute
  '/conductor-license': typeof ConductorLicenseRoute
  '/contact': typeof ContactRoute
  '/current-thank-you': typeof CurrentThankYouRoute
  '/customer-stories': typeof CustomerStoriesRoute
  '/daily-dbos-actions-count': typeof DailyDbosActionsCountRoute
  '/dbos-conductor': typeof DbosConductorRoute
  '/dbos-pricing': typeof DbosPricingRoute
  '/dbos-transact': typeof DbosTransactRoute
  '/dbos-user-group-meeting': typeof DbosUserGroupMeetingRoute
  '/opn-pledge': typeof OpnPledgeRoute
  '/partners': typeof PartnersRoute
  '/privacy': typeof PrivacyRoute
  '/serverless-past-present-future': typeof ServerlessPastPresentFutureRoute
  '/startup': typeof StartupRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/unbreakable-ai-workflows-bauplan': typeof UnbreakableAiWorkflowsBauplanRoute
  '/videos': typeof VideosRoute
  '/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo': typeof Webcast2025InReviewWithMikeStonebrakerAndAndyPavloRoute
  '/webcast-dbos-conductor-intro': typeof WebcastDbosConductorIntroRoute
  '/webcast-dbos-transact-typescript-2': typeof WebcastDbosTransactTypescript2Route
  '/blog/$slug': typeof BlogSlugRoute
  '/case-studies/$slug': typeof CaseStudiesSlugRoute
  '/compare/dbos-vs-temporal': typeof CompareDbosVsTemporalRoute
  '/jobs/keep-me-in-mind': typeof JobsKeepMeInMindRoute
  '/partnerships/$slug': typeof PartnershipsSlugRoute
  '/solutions/agentic-ai-platform': typeof SolutionsAgenticAiPlatformRoute
  '/solutions/cloud-modernization': typeof SolutionsCloudModernizationRoute
  '/solutions/cron-hosting': typeof SolutionsCronHostingRoute
  '/solutions/data-pipeline-platform': typeof SolutionsDataPipelinePlatformRoute
  '/solutions/durable-web3-workflows': typeof SolutionsDurableWeb3WorkflowsRoute
  '/solutions/pliable': typeof SolutionsPliableRoute
  '/webcast/$slug': typeof WebcastSlugRoute
  '/blog/': typeof BlogIndexRoute
  '/jobs/': typeof JobsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/agentic-ai-builder-early-access': typeof AgenticAiBuilderEarlyAccessRoute
  '/conductor-license': typeof ConductorLicenseRoute
  '/contact': typeof ContactRoute
  '/current-thank-you': typeof CurrentThankYouRoute
  '/customer-stories': typeof CustomerStoriesRoute
  '/daily-dbos-actions-count': typeof DailyDbosActionsCountRoute
  '/dbos-conductor': typeof DbosConductorRoute
  '/dbos-pricing': typeof DbosPricingRoute
  '/dbos-transact': typeof DbosTransactRoute
  '/dbos-user-group-meeting': typeof DbosUserGroupMeetingRoute
  '/opn-pledge': typeof OpnPledgeRoute
  '/partners': typeof PartnersRoute
  '/privacy': typeof PrivacyRoute
  '/serverless-past-present-future': typeof ServerlessPastPresentFutureRoute
  '/startup': typeof StartupRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/unbreakable-ai-workflows-bauplan': typeof UnbreakableAiWorkflowsBauplanRoute
  '/videos': typeof VideosRoute
  '/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo': typeof Webcast2025InReviewWithMikeStonebrakerAndAndyPavloRoute
  '/webcast-dbos-conductor-intro': typeof WebcastDbosConductorIntroRoute
  '/webcast-dbos-transact-typescript-2': typeof WebcastDbosTransactTypescript2Route
  '/blog/$slug': typeof BlogSlugRoute
  '/case-studies/$slug': typeof CaseStudiesSlugRoute
  '/compare/dbos-vs-temporal': typeof CompareDbosVsTemporalRoute
  '/jobs/keep-me-in-mind': typeof JobsKeepMeInMindRoute
  '/partnerships/$slug': typeof PartnershipsSlugRoute
  '/solutions/agentic-ai-platform': typeof SolutionsAgenticAiPlatformRoute
  '/solutions/cloud-modernization': typeof SolutionsCloudModernizationRoute
  '/solutions/cron-hosting': typeof SolutionsCronHostingRoute
  '/solutions/data-pipeline-platform': typeof SolutionsDataPipelinePlatformRoute
  '/solutions/durable-web3-workflows': typeof SolutionsDurableWeb3WorkflowsRoute
  '/solutions/pliable': typeof SolutionsPliableRoute
  '/webcast/$slug': typeof WebcastSlugRoute
  '/blog': typeof BlogIndexRoute
  '/jobs': typeof JobsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/agentic-ai-builder-early-access': typeof AgenticAiBuilderEarlyAccessRoute
  '/conductor-license': typeof ConductorLicenseRoute
  '/contact': typeof ContactRoute
  '/current-thank-you': typeof CurrentThankYouRoute
  '/customer-stories': typeof CustomerStoriesRoute
  '/daily-dbos-actions-count': typeof DailyDbosActionsCountRoute
  '/dbos-conductor': typeof DbosConductorRoute
  '/dbos-pricing': typeof DbosPricingRoute
  '/dbos-transact': typeof DbosTransactRoute
  '/dbos-user-group-meeting': typeof DbosUserGroupMeetingRoute
  '/opn-pledge': typeof OpnPledgeRoute
  '/partners': typeof PartnersRoute
  '/privacy': typeof PrivacyRoute
  '/serverless-past-present-future': typeof ServerlessPastPresentFutureRoute
  '/startup': typeof StartupRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/unbreakable-ai-workflows-bauplan': typeof UnbreakableAiWorkflowsBauplanRoute
  '/videos': typeof VideosRoute
  '/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo': typeof Webcast2025InReviewWithMikeStonebrakerAndAndyPavloRoute
  '/webcast-dbos-conductor-intro': typeof WebcastDbosConductorIntroRoute
  '/webcast-dbos-transact-typescript-2': typeof WebcastDbosTransactTypescript2Route
  '/blog/$slug': typeof BlogSlugRoute
  '/case-studies/$slug': typeof CaseStudiesSlugRoute
  '/compare/dbos-vs-temporal': typeof CompareDbosVsTemporalRoute
  '/jobs/keep-me-in-mind': typeof JobsKeepMeInMindRoute
  '/partnerships/$slug': typeof PartnershipsSlugRoute
  '/solutions/agentic-ai-platform': typeof SolutionsAgenticAiPlatformRoute
  '/solutions/cloud-modernization': typeof SolutionsCloudModernizationRoute
  '/solutions/cron-hosting': typeof SolutionsCronHostingRoute
  '/solutions/data-pipeline-platform': typeof SolutionsDataPipelinePlatformRoute
  '/solutions/durable-web3-workflows': typeof SolutionsDurableWeb3WorkflowsRoute
  '/solutions/pliable': typeof SolutionsPliableRoute
  '/webcast/$slug': typeof WebcastSlugRoute
  '/blog/': typeof BlogIndexRoute
  '/jobs/': typeof JobsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/about'
    | '/agentic-ai-builder-early-access'
    | '/conductor-license'
    | '/contact'
    | '/current-thank-you'
    | '/customer-stories'
    | '/daily-dbos-actions-count'
    | '/dbos-conductor'
    | '/dbos-pricing'
    | '/dbos-transact'
    | '/dbos-user-group-meeting'
    | '/opn-pledge'
    | '/partners'
    | '/privacy'
    | '/serverless-past-present-future'
    | '/startup'
    | '/terms-of-service'
    | '/unbreakable-ai-workflows-bauplan'
    | '/videos'
    | '/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo'
    | '/webcast-dbos-conductor-intro'
    | '/webcast-dbos-transact-typescript-2'
    | '/blog/$slug'
    | '/case-studies/$slug'
    | '/compare/dbos-vs-temporal'
    | '/jobs/keep-me-in-mind'
    | '/partnerships/$slug'
    | '/solutions/agentic-ai-platform'
    | '/solutions/cloud-modernization'
    | '/solutions/cron-hosting'
    | '/solutions/data-pipeline-platform'
    | '/solutions/durable-web3-workflows'
    | '/solutions/pliable'
    | '/webcast/$slug'
    | '/blog/'
    | '/jobs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/about'
    | '/agentic-ai-builder-early-access'
    | '/conductor-license'
    | '/contact'
    | '/current-thank-you'
    | '/customer-stories'
    | '/daily-dbos-actions-count'
    | '/dbos-conductor'
    | '/dbos-pricing'
    | '/dbos-transact'
    | '/dbos-user-group-meeting'
    | '/opn-pledge'
    | '/partners'
    | '/privacy'
    | '/serverless-past-present-future'
    | '/startup'
    | '/terms-of-service'
    | '/unbreakable-ai-workflows-bauplan'
    | '/videos'
    | '/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo'
    | '/webcast-dbos-conductor-intro'
    | '/webcast-dbos-transact-typescript-2'
    | '/blog/$slug'
    | '/case-studies/$slug'
    | '/compare/dbos-vs-temporal'
    | '/jobs/keep-me-in-mind'
    | '/partnerships/$slug'
    | '/solutions/agentic-ai-platform'
    | '/solutions/cloud-modernization'
    | '/solutions/cron-hosting'
    | '/solutions/data-pipeline-platform'
    | '/solutions/durable-web3-workflows'
    | '/solutions/pliable'
    | '/webcast/$slug'
    | '/blog'
    | '/jobs'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/about'
    | '/agentic-ai-builder-early-access'
    | '/conductor-license'
    | '/contact'
    | '/current-thank-you'
    | '/customer-stories'
    | '/daily-dbos-actions-count'
    | '/dbos-conductor'
    | '/dbos-pricing'
    | '/dbos-transact'
    | '/dbos-user-group-meeting'
    | '/opn-pledge'
    | '/partners'
    | '/privacy'
    | '/serverless-past-present-future'
    | '/startup'
    | '/terms-of-service'
    | '/unbreakable-ai-workflows-bauplan'
    | '/videos'
    | '/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo'
    | '/webcast-dbos-conductor-intro'
    | '/webcast-dbos-transact-typescript-2'
    | '/blog/$slug'
    | '/case-studies/$slug'
    | '/compare/dbos-vs-temporal'
    | '/jobs/keep-me-in-mind'
    | '/partnerships/$slug'
    | '/solutions/agentic-ai-platform'
    | '/solutions/cloud-modernization'
    | '/solutions/cron-hosting'
    | '/solutions/data-pipeline-platform'
    | '/solutions/durable-web3-workflows'
    | '/solutions/pliable'
    | '/webcast/$slug'
    | '/blog/'
    | '/jobs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  AboutRoute: typeof AboutRoute
  AgenticAiBuilderEarlyAccessRoute: typeof AgenticAiBuilderEarlyAccessRoute
  ConductorLicenseRoute: typeof ConductorLicenseRoute
  ContactRoute: typeof ContactRoute
  CurrentThankYouRoute: typeof CurrentThankYouRoute
  CustomerStoriesRoute: typeof CustomerStoriesRoute
  DailyDbosActionsCountRoute: typeof DailyDbosActionsCountRoute
  DbosConductorRoute: typeof DbosConductorRoute
  DbosPricingRoute: typeof DbosPricingRoute
  DbosTransactRoute: typeof DbosTransactRoute
  DbosUserGroupMeetingRoute: typeof DbosUserGroupMeetingRoute
  OpnPledgeRoute: typeof OpnPledgeRoute
  PartnersRoute: typeof PartnersRoute
  PrivacyRoute: typeof PrivacyRoute
  ServerlessPastPresentFutureRoute: typeof ServerlessPastPresentFutureRoute
  StartupRoute: typeof StartupRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  UnbreakableAiWorkflowsBauplanRoute: typeof UnbreakableAiWorkflowsBauplanRoute
  VideosRoute: typeof VideosRoute
  Webcast2025InReviewWithMikeStonebrakerAndAndyPavloRoute: typeof Webcast2025InReviewWithMikeStonebrakerAndAndyPavloRoute
  WebcastDbosConductorIntroRoute: typeof WebcastDbosConductorIntroRoute
  WebcastDbosTransactTypescript2Route: typeof WebcastDbosTransactTypescript2Route
  BlogSlugRoute: typeof BlogSlugRoute
  CaseStudiesSlugRoute: typeof CaseStudiesSlugRoute
  CompareDbosVsTemporalRoute: typeof CompareDbosVsTemporalRoute
  JobsKeepMeInMindRoute: typeof JobsKeepMeInMindRoute
  PartnershipsSlugRoute: typeof PartnershipsSlugRoute
  SolutionsAgenticAiPlatformRoute: typeof SolutionsAgenticAiPlatformRoute
  SolutionsCloudModernizationRoute: typeof SolutionsCloudModernizationRoute
  SolutionsCronHostingRoute: typeof SolutionsCronHostingRoute
  SolutionsDataPipelinePlatformRoute: typeof SolutionsDataPipelinePlatformRoute
  SolutionsDurableWeb3WorkflowsRoute: typeof SolutionsDurableWeb3WorkflowsRoute
  SolutionsPliableRoute: typeof SolutionsPliableRoute
  WebcastSlugRoute: typeof WebcastSlugRoute
  BlogIndexRoute: typeof BlogIndexRoute
  JobsIndexRoute: typeof JobsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agentic-ai-builder-early-access': {
      id: '/agentic-ai-builder-early-access'
      path: '/agentic-ai-builder-early-access'
      fullPath: '/agentic-ai-builder-early-access'
      preLoaderRoute: typeof AgenticAiBuilderEarlyAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conductor-license': {
      id: '/conductor-license'
      path: '/conductor-license'
      fullPath: '/conductor-license'
      preLoaderRoute: typeof ConductorLicenseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/current-thank-you': {
      id: '/current-thank-you'
      path: '/current-thank-you'
      fullPath: '/current-thank-you'
      preLoaderRoute: typeof CurrentThankYouRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer-stories': {
      id: '/customer-stories'
      path: '/customer-stories'
      fullPath: '/customer-stories'
      preLoaderRoute: typeof CustomerStoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/daily-dbos-actions-count': {
      id: '/daily-dbos-actions-count'
      path: '/daily-dbos-actions-count'
      fullPath: '/daily-dbos-actions-count'
      preLoaderRoute: typeof DailyDbosActionsCountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dbos-conductor': {
      id: '/dbos-conductor'
      path: '/dbos-conductor'
      fullPath: '/dbos-conductor'
      preLoaderRoute: typeof DbosConductorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dbos-pricing': {
      id: '/dbos-pricing'
      path: '/dbos-pricing'
      fullPath: '/dbos-pricing'
      preLoaderRoute: typeof DbosPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dbos-transact': {
      id: '/dbos-transact'
      path: '/dbos-transact'
      fullPath: '/dbos-transact'
      preLoaderRoute: typeof DbosTransactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dbos-user-group-meeting': {
      id: '/dbos-user-group-meeting'
      path: '/dbos-user-group-meeting'
      fullPath: '/dbos-user-group-meeting'
      preLoaderRoute: typeof DbosUserGroupMeetingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opn-pledge': {
      id: '/opn-pledge'
      path: '/opn-pledge'
      fullPath: '/opn-pledge'
      preLoaderRoute: typeof OpnPledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners': {
      id: '/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof PartnersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/serverless-past-present-future': {
      id: '/serverless-past-present-future'
      path: '/serverless-past-present-future'
      fullPath: '/serverless-past-present-future'
      preLoaderRoute: typeof ServerlessPastPresentFutureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/startup': {
      id: '/startup'
      path: '/startup'
      fullPath: '/startup'
      preLoaderRoute: typeof StartupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unbreakable-ai-workflows-bauplan': {
      id: '/unbreakable-ai-workflows-bauplan'
      path: '/unbreakable-ai-workflows-bauplan'
      fullPath: '/unbreakable-ai-workflows-bauplan'
      preLoaderRoute: typeof UnbreakableAiWorkflowsBauplanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/videos': {
      id: '/videos'
      path: '/videos'
      fullPath: '/videos'
      preLoaderRoute: typeof VideosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo': {
      id: '/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo'
      path: '/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo'
      fullPath: '/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo'
      preLoaderRoute: typeof Webcast2025InReviewWithMikeStonebrakerAndAndyPavloRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webcast-dbos-conductor-intro': {
      id: '/webcast-dbos-conductor-intro'
      path: '/webcast-dbos-conductor-intro'
      fullPath: '/webcast-dbos-conductor-intro'
      preLoaderRoute: typeof WebcastDbosConductorIntroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webcast-dbos-transact-typescript-2': {
      id: '/webcast-dbos-transact-typescript-2'
      path: '/webcast-dbos-transact-typescript-2'
      fullPath: '/webcast-dbos-transact-typescript-2'
      preLoaderRoute: typeof WebcastDbosTransactTypescript2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/case-studies/$slug': {
      id: '/case-studies/$slug'
      path: '/case-studies/$slug'
      fullPath: '/case-studies/$slug'
      preLoaderRoute: typeof CaseStudiesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare/dbos-vs-temporal': {
      id: '/compare/dbos-vs-temporal'
      path: '/compare/dbos-vs-temporal'
      fullPath: '/compare/dbos-vs-temporal'
      preLoaderRoute: typeof CompareDbosVsTemporalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/': {
      id: '/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof JobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/keep-me-in-mind': {
      id: '/jobs/keep-me-in-mind'
      path: '/jobs/keep-me-in-mind'
      fullPath: '/jobs/keep-me-in-mind'
      preLoaderRoute: typeof JobsKeepMeInMindRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partnerships/$slug': {
      id: '/partnerships/$slug'
      path: '/partnerships/$slug'
      fullPath: '/partnerships/$slug'
      preLoaderRoute: typeof PartnershipsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/agentic-ai-platform': {
      id: '/solutions/agentic-ai-platform'
      path: '/solutions/agentic-ai-platform'
      fullPath: '/solutions/agentic-ai-platform'
      preLoaderRoute: typeof SolutionsAgenticAiPlatformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/cloud-modernization': {
      id: '/solutions/cloud-modernization'
      path: '/solutions/cloud-modernization'
      fullPath: '/solutions/cloud-modernization'
      preLoaderRoute: typeof SolutionsCloudModernizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/cron-hosting': {
      id: '/solutions/cron-hosting'
      path: '/solutions/cron-hosting'
      fullPath: '/solutions/cron-hosting'
      preLoaderRoute: typeof SolutionsCronHostingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/data-pipeline-platform': {
      id: '/solutions/data-pipeline-platform'
      path: '/solutions/data-pipeline-platform'
      fullPath: '/solutions/data-pipeline-platform'
      preLoaderRoute: typeof SolutionsDataPipelinePlatformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/durable-web3-workflows': {
      id: '/solutions/durable-web3-workflows'
      path: '/solutions/durable-web3-workflows'
      fullPath: '/solutions/durable-web3-workflows'
      preLoaderRoute: typeof SolutionsDurableWeb3WorkflowsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/solutions/pliable': {
      id: '/solutions/pliable'
      path: '/solutions/pliable'
      fullPath: '/solutions/pliable'
      preLoaderRoute: typeof SolutionsPliableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webcast/$slug': {
      id: '/webcast/$slug'
      path: '/webcast/$slug'
      fullPath: '/webcast/$slug'
      preLoaderRoute: typeof WebcastSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  AboutRoute: AboutRoute,
  AgenticAiBuilderEarlyAccessRoute: AgenticAiBuilderEarlyAccessRoute,
  ConductorLicenseRoute: ConductorLicenseRoute,
  ContactRoute: ContactRoute,
  CurrentThankYouRoute: CurrentThankYouRoute,
  CustomerStoriesRoute: CustomerStoriesRoute,
  DailyDbosActionsCountRoute: DailyDbosActionsCountRoute,
  DbosConductorRoute: DbosConductorRoute,
  DbosPricingRoute: DbosPricingRoute,
  DbosTransactRoute: DbosTransactRoute,
  DbosUserGroupMeetingRoute: DbosUserGroupMeetingRoute,
  OpnPledgeRoute: OpnPledgeRoute,
  PartnersRoute: PartnersRoute,
  PrivacyRoute: PrivacyRoute,
  ServerlessPastPresentFutureRoute: ServerlessPastPresentFutureRoute,
  StartupRoute: StartupRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  UnbreakableAiWorkflowsBauplanRoute: UnbreakableAiWorkflowsBauplanRoute,
  VideosRoute: VideosRoute,
  Webcast2025InReviewWithMikeStonebrakerAndAndyPavloRoute:
    Webcast2025InReviewWithMikeStonebrakerAndAndyPavloRoute,
  WebcastDbosConductorIntroRoute: WebcastDbosConductorIntroRoute,
  WebcastDbosTransactTypescript2Route: WebcastDbosTransactTypescript2Route,
  BlogSlugRoute: BlogSlugRoute,
  CaseStudiesSlugRoute: CaseStudiesSlugRoute,
  CompareDbosVsTemporalRoute: CompareDbosVsTemporalRoute,
  JobsKeepMeInMindRoute: JobsKeepMeInMindRoute,
  PartnershipsSlugRoute: PartnershipsSlugRoute,
  SolutionsAgenticAiPlatformRoute: SolutionsAgenticAiPlatformRoute,
  SolutionsCloudModernizationRoute: SolutionsCloudModernizationRoute,
  SolutionsCronHostingRoute: SolutionsCronHostingRoute,
  SolutionsDataPipelinePlatformRoute: SolutionsDataPipelinePlatformRoute,
  SolutionsDurableWeb3WorkflowsRoute: SolutionsDurableWeb3WorkflowsRoute,
  SolutionsPliableRoute: SolutionsPliableRoute,
  WebcastSlugRoute: WebcastSlugRoute,
  BlogIndexRoute: BlogIndexRoute,
  JobsIndexRoute: JobsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
